import { render, staticRenderFns } from "./DMCA.vue?vue&type=template&id=4f3cd556&scoped=true"
import script from "./DMCA.vue?vue&type=script&lang=js"
export * from "./DMCA.vue?vue&type=script&lang=js"
import style0 from "./DMCA.vue?vue&type=style&index=0&id=4f3cd556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3cd556",
  null
  
)

export default component.exports